export const toastCopyDa = {
    saved: "Gemt",
    savedForNow: "Gemt foreløbig.",
    savedSuccessfully: "Gemt",
    errorSaving: "Fejl ved gemning",
    errorSavingTracker: "Fejl ved gemning af tracker",
    updateFailed: "Opdatering mislykkedes",
    errorUpdating: "Fejl ved opdatering",
    errorCreating: "Fejl ved oprettelse",
    errorCreatingInput: "Fejl ved oprettelse af indtastning",
    errorCreatingDiaryLog: "Fejl ved oprettelse af dagbogslog",
    errorCreatingEvent: "Fejl ved oprettelse af begivenhed",
    errorUpdatingEvent: "Fejl ved opdatering af begivenhed",
    errorUpdatingProfile: "Fejl ved opdatering af profil, prøv igen",
    errorWhileUploading: "Fejl under upload",
    refreshAndRetry: "Fejl, opdater siden og prøv igen",
    noDataReturned: "Ingen data returneret",
    settingsSaved: "Indstillinger gemt",
    copiedToClipboard: "Kopieret til udklipsholder",
    linkCopiedToClipboard: "Link kopieret til udklipsholder",
    pleaseSelectFile: "Vælg venligst en fil",
    pasteImageFromClipboard: "Indsæt et billede fra udklipsholderen (Ctrl+V eller Cmd+V)",
    loggedOutSuccess: "Logget ud",
    loggingIn: "Logger ind",
    errorLoggingIn: "Fejl ved login",
    loginSuccessful: "Login lykkedes",
    signUpSuccessful: "Konto oprettet",
    transferRequested: "Overførsel anmodet - tjek din e-mail for at sikre, at den er gået igennem.",
    organisationAdded: "Organisation tilføjet",
    organisationAlreadyAdded: "Organisation allerede tilføjet",
    deletionRequestSent: "Sletningsanmodning sendt",
    userAuthenticated: "Bruger godkendt",
    codeIncorrect: "Forkert kode",
    codeCorrect: "Korrekt kode",
    errorSigningIn: "Fejl ved login",
    otpFailedToSend: "Engangskode kunne ikke sendes",
    passwordUpdatedSuccess: "Adgangskode opdateret!",
    emailOrPasswordIncorrect: "Forkert e-mail eller adgangskode",
    emailAlreadyRegistered:
        "Du har muligvis allerede en konto med denne e-mail. Log ind, eller nulstil din adgangskode.",
    phoneNumberConfirmed: "Telefonnummer bekræftet",
    errorConfirmingPhoneNumber: "Fejl ved bekræftelse af telefonnummer",
    profileUpdatedSuccess: "Profil opdateret",
    professionalDetailsSaved: "Faglige oplysninger gemt!",
    failedUpdateProfessionalDetails: "Kunne ikke opdatere faglige oplysninger",
    templateCreatedSuccess: "Skabelon oprettet!",
    templatesCreatedSuccess: (count) => (count === 1 ? "Skabelon oprettet!" : `${count} skabeloner oprettet!`),
    failedCreateTemplate: "Kunne ikke oprette skabelon",
    templateUpdatedSuccess: "Skabelon opdateret",
    failedUpdateTemplate: "Kunne ikke opdatere skabelon",
    templateDeletedSuccess: "Skabelon slettet",
    failedDeleteTemplate: "Kunne ikke slette skabelon",
    templateDuplicatedSuccess: "Skabelon duplikeret",
    failedDuplicateTemplate: "Kunne ikke duplikere skabelon",
    templateSharedSuccess: "Skabelon delt",
    errorSharingTemplate: (message) => `Fejl ved deling af skabelon: ${message}`,
    analyticsViewSharedSuccess: "Visning delt",
    errorSharingAnalyticsView: (message) => `Fejl ved deling af visning: ${message}`,
    analyticsViewUnsharedSuccess: "Delt visning fjernet",
    errorUnsharingAnalyticsView: (message) => `Fejl ved fjernelse af delt visning: ${message}`,
    trackerSaved: "Tracker gemt",
    entryUpdatedSuccess: "Indtastning opdateret",
    entrySaved: "Indtastning gemt",
    entryDeleted: "Indtastning slettet",
    entryTimingUpdated: "Indtastningstidspunkt opdateret",
    scheduleUpdated: "Tidsplan opdateret",
    entryRemovedFromSchedule: "Indtastning fjernet fra tidsplan",
    entryAssignedToScheduleStep: "Indtastning tildelt tidsplantrin",
    stepAlreadyOccupied: "Dette trin har allerede en indtastning.",
    diaryUpdatedSuccess: "Dagbog opdateret",
    diaryInputsAddedSuccess: "Dagbogsindtastninger tilføjet",
    diaryDiscardedSuccess: "Dagbog kasseret",
    diaryReinstatedSuccess: "Dagbog genoprettet",
    diaryDischargedSuccess: "Dagbog udskrevet",
    diaryEnded: "Dagbog afsluttet",
    labelCreated: "Etiket oprettet",
    labelUpdated: "Etiket opdateret",
    labelDeleted: "Etiket slettet",
    labelsUpdated: "Etiketter opdateret",
    tableSettingsSaved: "Tabelindstillinger gemt",
    detailsSaved: "Dine oplysninger er gemt.",
    hospitalNumberRequired: "Hospitalsnummer er påkrævet",
    couldNotSaveHospitalNumber: "Kunne ikke gemme hospitalsnummer",
    sharedAttributesUpdated: "Delte attributter opdateret",
    errorUpdatingSharedAttributes: "Fejl ved opdatering af delte attributter",
    sharedAttributesCreated: "Delte attributter oprettet",
    errorCreatingSharedAttributes: "Fejl ved oprettelse af delte attributter",
    diaryAccessSaved: "Dagbogsadgang gemt",
    failedSaveDiaryAccess: "Kunne ikke gemme dagbogsadgang",
    joinedDateGroupSuccess: "Tilsluttet datogruppe",
    failedJoinDateGroup: (message) => `Kunne ikke tilslutte datogruppe: ${message}`,
    questionnaireStopped: "Spørgeskema stoppet",
    errorStoppingQuestionnaire: "Fejl ved stop af spørgeskema",
    consentAddedToDiary: "Samtykke tilføjet til dagbogen",
    errorAddingConsentToDiary: "Kunne ikke tilføje samtykke",
    eventSaved: "Begivenhed gemt",
    eventUpdated: "Begivenhed opdateret",
    eventDeletedSuccess: "Begivenhed slettet",
    eventTrackerLinked: "Begivenhed og tracker kædet sammen",
    errorLinkingEventTracker: (message) => `Fejl ved sammenkædning af begivenhed og tracker. ${message}`,
    surgerySaved: "Operation gemt",
    errorCreatingSurgery: "Fejl ved oprettelse af operation",
    surgeryOptionUpdated: "Operationsvalg opdateret",
    errorUpdatingSurgeryOption: "Fejl ved opdatering af operationsvalg",
    newSurgeryOptionSaved: "Nyt operationsvalg gemt",
    consultationSaved: "Konsultation gemt",
    errorCreatingConsultation: "Fejl ved oprettelse af konsultation",
    errorUpdatingConsultation: "Fejl ved opdatering af konsultation",
    imagingRequestSaved: "Billeddiagnostisk anmodning gemt",
    errorCreatingImagingRequest: "Fejl ved oprettelse af billeddiagnostisk anmodning",
    injectionDetailsUpdated: "Injektionsdetaljer opdateret",
    errorUpdatingInjectionDetails: "Fejl ved opdatering af injektionsdetaljer",
    injectionDiaryDefaultSaved: "Standard for injektionsdagbog gemt",
    errorSavingInjectionDiaryDefault: "Fejl ved gemning af standard for injektionsdagbog",
    diaryInjectionAdded: "Injektion tilføjet til dagbog",
    errorCreatingDiaryInjection: "Fejl ved oprettelse af dagbogsinjektion",
    injectionContentUpdated: "Injektionsindhold opdateret",
    failedUpdateInjectionContent: "Kunne ikke opdatere injektionsindhold",
    injectionContentDeleted: "Injektionsindhold slettet",
    failedDeleteInjectionContent: "Kunne ikke slette injektionsindhold",
    publicStatusUpdated: "Offentlig status opdateret",
    failedUpdatePublicStatus: "Kunne ikke opdatere offentlig status",
    injectionLocationUpdated: "Injektionssted opdateret",
    failedUpdateInjectionLocation: "Kunne ikke opdatere injektionssted",
    newInjectionLocationCreated: "Nyt injektionssted oprettet",
    failedCreateInjectionLocation: "Kunne ikke oprette injektionssted",
    newInjectionContentsCreated: "Nyt injektionsindhold oprettet",
    failedCreateInjectionContents: "Kunne ikke oprette injektionsindhold",
    failedSaveInjectionDetails: "Kunne ikke gemme injektionsdetaljer",
    diaryShockwaveAdded: "Stødbølge tilføjet til dagbog",
    errorCreatingDiaryShockwave: "Fejl ved oprettelse af dagbogsstødbølge",
    diaryShockwaveSaved: "Dagbogsstødbølge gemt",
    shockwaveDetailsUpdated: "Stødbølgedetaljer opdateret",
    errorUpdatingShockwaveDetails: "Fejl ved opdatering af stødbølgedetaljer",
    shockwaveDiaryDefaultSaved: "Standard for stødbølgedagbog gemt",
    errorSavingShockwaveDiaryDefault: "Fejl ved gemning af standard for stødbølgedagbog",
    shockwaveDetailsRemoved: "Stødbølgedetaljer fjernet",
    failedSaveShockwaveDetails: "Kunne ikke gemme stødbølgedetaljer",
    scheduleUpdatedSuccess: "Tidsplan opdateret",
    failedUpdateSchedule: "Kunne ikke opdatere tidsplan",
    scheduleDraftCreated: "Kladde til tidsplan oprettet",
    failedCreateScheduleFromDraft: "Kunne ikke oprette tidsplan fra kladden",
    failedUpdatePublishStatus: "Kunne ikke opdatere publiceringsstatus",
    formUpdated: "Formular opdateret",
    failedUpdateForm: "Kunne ikke opdatere formular",
    formDraftCreated: "Kladdeformular oprettet",
    failedCreateFormFromDraft: "Kunne ikke oprette formular fra kladden",
    pageSaved: "Side gemt",
    failedSavePage: "Kunne ikke gemme side",
    pageDeleted: "Side slettet",
    failedDeletePage: "Kunne ikke slette side",
    questionSaved: "Spørgsmål gemt",
    failedSaveQuestion: "Kunne ikke gemme spørgsmål",
    questionDeleted: "Spørgsmål slettet",
    failedDeleteQuestion: "Kunne ikke slette spørgsmål",
    patientAddedSuccess: "Patient tilføjet!",
    emailWordsUpdatedSuccess: "E-mailtekst opdateret",
    failedUpdateEmailWords: "Kunne ikke opdatere e-mailtekst",
    emailSentSuccess: "E-mail sendt",
    diaryAlreadyRead: "Dagbog allerede læst",
    noLastReadAction: "Ingen seneste læsehandling fundet",
    actionComplete: (actionName) => `${actionName} fuldført`,
    footLogCreatedSuccess: "Fodlog oprettet",
    imageUploadedSuccess: "Billede uploadet",
    imageLabelCreatedSuccess: "Billedetiket oprettet",
    qipPermissionsUpdated: "QIP-tilladelser opdateret",
    qipPermissionsUpdateFailed: "QIP-tilladelser kunne ikke opdateres",
    riskAssessmentUpdateFailed: "Risikovurdering kunne ikke opdateres",
    footCommentSubmitted: (comment) => `Du har sendt følgende kommentar:\n${comment}`,
    qrCodeNotReady: "QR-kode ikke klar",
    qrCodeCopiedToClipboard: "QR-kode kopieret til udklipsholder",
    couldNotCopyQrImage: "Kunne ikke kopiere QR-billede. Prøv et skærmbillede i stedet.",
    inviteSent: "Invitation sendt",
    organisationRoleAddedSuccess: "Organisationsrolle tilføjet",
    errorAddingOrganisationRole: (message) => `Fejl ved tilføjelse af organisationsrolle: ${message}`,
    organisationRoleUpdatedSuccess: "Organisationsrolle opdateret",
    errorUpdatingOrganisationRole: (message) => `Fejl ved opdatering af organisationsrolle: ${message}`,
    organisationRoleDeletedSuccess: "Organisationsrolle slettet",
    errorDeletingOrganisationRole: (message) => `Fejl ved sletning af organisationsrolle: ${message}`,
    secretaryAddedToOrganisation: "Sekretærtildeling tilføjet",
    errorAddingSecretaryToOrganisation: (message) => `Fejl ved tilføjelse af sekretærtildeling: ${message}`,
    defaultSecretarySet: "Standardkontaktperson opdateret",
    errorSettingDefaultSecretary: (message) => `Fejl ved valg af standardkontaktperson: ${message}`,
    defaultSecretaryCleared: "Standardkontaktperson fjernet",
    errorClearingDefaultSecretary: (message) => `Fejl ved fjernelse af standardkontaktperson: ${message}`,
    secretaryRemovedFromOrganisation: "Sekretærtildeling fjernet",
    errorRemovingSecretaryFromOrganisation: (message) => `Fejl ved fjernelse af sekretærtildeling: ${message}`,
    newOrganisationSaved: "Ny organisation gemt",
    organizationCreatedSuccess: "Organisation oprettet!",
    audiencesUpdatedSuccess: "Målgrupper opdateret",
    errorUpdatingAudiences: "Fejl ved opdatering af målgrupper",
    labelAccessUpdated: "Etiketadgang opdateret",
    accessUpdated: "Adgang opdateret",
    photoUpdatedSuccess: "Foto opdateret",
    failedUpdatePhoto: "Kunne ikke opdatere foto",
    photoDeletedSuccess: "Foto slettet",
    failedDeletePhoto: "Kunne ikke slette foto",
    logoUpdatedSuccess: "Logo opdateret",
    failedUpdateLogo: "Kunne ikke opdatere logo",
    logoDeletedSuccess: "Logo slettet",
    failedDeleteLogo: "Kunne ikke slette logo",
    smsDisabledInKnock: "SMS deaktiveret i Knock",
    failedUpdateKnockPreferences: "Kunne ikke opdatere Knock-indstillinger",
    magicLinkGenerated: "Magisk link genereret",
    errorImpersonatingUser: "Fejl ved efterligning af bruger",
    fieldUpdatedSuccess: (field) => `${field} er opdateret.`,
    lockUnlockReasonRequired: (action) => `${action === "lock" ? "Godkendelses" : "Oplåsnings"}grund er påkrævet`,
    lockUnlockSuccess: (action, count) => `${action === "lock" ? "Låste" : "Låste op"} ${count} dagbøger`,
    errorResolvedSuccess: "Fejl løst",
    failedResolveError: (message) => `Kunne ikke løse fejl: ${message}`,
    healthCheckCompleted: (message) => `Sundhedstjek fuldført: ${message}`,
    healthCheckFailed: (message) => `Sundhedstjek mislykkedes: ${message}`,
    expectedCountUpdatedSuccess: "Forventet antal opdateret",
    failedUpdateExpectedCount: (message) => `Kunne ikke opdatere forventet antal: ${message}`,
    fixedRecords: (fixed, failed) => `Rettede ${fixed} poster${failed ? `, ${failed} mislykkedes` : ""}`,
    failedFixSharedAttributes: (message) => `Kunne ikke rette delte attributter: ${message}`,
    failedAssignRole: (message) => `Kunne ikke tildele rolle: ${message}`,
    failedLoadMessages: "Kunne ikke indlæse beskeder",
    loggedInSuccess: "Logget ind",
    unknownLoginError: "Ukendt loginfejl",
    userDeleted: "Bruger slettet",
    passwordSetSuccess: "Adgangskode oprettet!",
    emailVerificationSent: "E-mailbekræftelse sendt",
    verificationCodeSent: "Bekræftelseskode sendt",
    verificationCodeSentEmail: "Bekræftelseskode sendt til din e-mail",
    failedSendVerificationCode: "Kunne ikke sende bekræftelseskode",
    emailVerificationFailed: "E-mailbekræftelse mislykkedes",
    emailVerified: "E-mail bekræftet",
    emailVerifiedShort: "E-mail bekræftet!",
    invalidVerificationCode: "Ugyldig bekræftelseskode",
    emailSetSuccess: "E-mail angivet",
    emailSavedToProfileToast: "E-mailadressen er gemt i din profil",
    emailUpdatedSuccessToast: "E-mailadresse opdateret",
    superUserStatusUpdated: "Superbrugerstatus opdateret",
    userInvited: "Bruger inviteret",
    profileAttributeLocked: "Profilattribut er låst",
    addressAlreadyInUse: "Den adresse er allerede i brug.",
    mustBeSignedIn: "Du skal være logget ind.",
    contactPersonRequired: "Kontaktperson er påkrævet.",
    somethingWentWrong: "Noget gik galt. Prøv igen.",
    resultsSentToEmail: "Resultater sendt til din e-mail!",
    resultsEmailSendFailed: "Dine resultater er klar, men e-mailen kunne ikke sendes. Prøv venligst igen senere.",
    fixHighlightedFieldsBeforeInvite: "Ret venligst de markerede felter, før du sender invitationen.",
    pdfDownloaded: "PDF downloadet",
    pdfDownloadFailed: "PDF-download mislykkedes",
    pdfGenerationFailed: "PDF-generering mislykkedes",
    questionnaireResumed: "Spørgeskema genoptaget",
    errorResumingQuestionnaire: "Fejl ved genoptagelse af spørgeskema",
    trackerDeletedSuccess: "Tracker slettet",
    diaryCreatedSuccess: "Dagbog oprettet",
    diaryDeletedSuccess: "Dagbog slettet",
    templateSavedSuccess: "Skabelon gemt",
    failedSaveTemplate: "Skabelon kunne ikke gemmes",
    diaryAccessRemoved: "Dagbogadgang fjernet",
    failedRemoveDiaryAccess: "Dagbogadgang kunne ikke fjernes",
    entryRemindersTriggered: "Indtastningspåmindelser udløst for tracker",
    correctionSaved: "Rettelse gemt",
    correctionReasonRequired: "Rettelsesgrund er påkrævet",
    errorAddingPatient: "Fejl ved tilføjelse af patient, opdater siden og prøv igen.",
    invalidDate: "Ugyldig dato",
    failedCreateDiary: (message) => `Kunne ikke oprette dagbog: ${message}`,
    failedUpdateEntry: (message) => `Kunne ikke opdatere indtastning: ${message}`,
    failedDeleteSchedule: (message) => `Kunne ikke slette tidsplan: ${message}`,
    failedCopySchedule: (message) => `Kunne ikke kopiere tidsplan: ${message}`,
    errorAddingUserToOrganisation: (message) => `Fejl ved tilføjelse af bruger til organisation: ${message}`,
    emailRequiredRefresh: "Vi har brug for din e-mail. Opdater siden og indsend formularen igen.",
    templateStillLoading: "Skabelon indlæses stadig. Prøv igen om et øjeblik.",
    phoneUpdatedSuccess: "Telefonnummer opdateret",
    failedUpdatePhone: "Kunne ikke opdatere telefonnummer. Prøv igen.",
    completeRequiredFields: (fieldsList) => `Udfyld venligst følgende obligatoriske felter:\n${fieldsList}`,
    missingEntry: "Manglende indtastning",
    formSubmissionError: (message) => `Fejl ved indsendelse af formular: ${message}`,
    organisationDeleted: "Organisation slettet",
    noRowsToExport: "Ingen rækker på denne side at eksportere",
    exportedChangeEventsFromPage: (count) => `Eksporterede ${count} ændringshændelser fra denne side`,
    noChangeEventsMatchFilters: "Ingen ændringshændelser matcher disse filtre",
    exportedChangeEvents: (count) => `Eksporterede ${count} ændringshændelser`,
    mustSignInToExportSnapshot: "Du skal være logget ind for at eksportere et snapshot",
    noDiariesToExport: "Ingen dagbøger at eksportere - juster søgning eller filtre",
    chooseSnapshotDateTime: "Vælg dato og tidspunkt for snapshot",
    snapshotExported: (count, dateTime) =>
        count === 1
            ? `Snapshot eksporteret for 1 dagbog pr. ${dateTime} UTC`
            : `Snapshot eksporteret for ${count} dagbøger pr. ${dateTime} UTC`,
    snapshotExportFailed: "Snapshot-eksport mislykkedes",
    exportFailed: "Eksport mislykkedes",
    exportedChangeEventsTruncated: (exported, total) =>
        `Eksporterede første ${exported} af ${total} matchende ændringshændelser (grænse: 10.000 rækker)`,
    printing: "Udskriver",
    failedGeneratePrintUrl: "Kunne ikke oprette udskrifts-URL",
    reportPrintQueued:
        "Rapport sat i kø. Den genereres på serveren inden længe - prøv at udskrive igen om et par minutter.",
    reportPrintRendering: "Genererer din rapport...",
    reportPrintRefreshing: "Dagbog opdateret - genererer en ny rapport...",
    reportPrintPreparing: "Forbereder din rapport...",
    reportPrintTimeout: "Rapporten tager længere tid end forventet. Prøv at udskrive igen om et par minutter.",
    unknownError: "Ukendt fejl",
    failedCreateOrganisation: "Kunne ikke oprette organisation",
    correctionFailed: "Korrektion mislykkedes",
    couldNotSaveProcedureDate: "Kunne ikke gemme din proceduredato",
    couldNotSave: "Kunne ikke gemme",
    invalidFieldSelection: "Et eller flere felter har et ugyldigt valg - tjek formularen og prøv igen.",
    completeAllRequiredFieldsBeforeSaving: "Udfyld venligst alle obligatoriske felter, før du gemmer.",
    detailsAlreadySaved: "Disse oplysninger er allerede gemt.",
    unableToSaveInjectionDetails: "Kunne ikke gemme injektionsdetaljer. Tjek dine indtastninger og prøv igen.",
    unableToSaveShockwaveDetails: "Kunne ikke gemme stødbølgedetaljer. Tjek dine indtastninger og prøv igen.",
    invitationLinkExpired: "Det invitationslink er udløbet. Angiv din e-mailadresse for at få en ny kode.",
    invitationLinkInvalid: "Det link er ugyldigt eller udløbet. Angiv din e-mailadresse for at få en ny kode.",
    confirmAccountCouldNotTextTryEmail:
        "Vi kunne ikke sende en SMS til dette nummer. Prøv e-mailadressen fra din invitation, hvis du har en.",
    confirmAccountNoAccountForDetails:
        "Vi kunne ikke finde en konto med disse oplysninger. Tjek dem, eller kontakt teamet, der inviterede dig.",
    smsVerificationUnavailableForNumber:
        "SMS-bekræftelse er endnu ikke tilgængelig for dette nummer. Brug e-mailen fra din invitation, eller kontakt teamet, der inviterede dig.",
    smsVerificationTextFailedSignup:
        "Vi kunne ikke sende en bekræftelsestekst til dette nummer. Hvis du har en konto, så log ind med din e-mail, eller kontakt teamet, der inviterede dig.",
    smsSignInNotEnabledForProject:
        "SMS-login er ikke aktiveret for dette projekt. Teamet, der inviterede dig, eller support kan hjælpe.",
    smsCouldNotSendCheckNumber:
        "Vi kunne ikke sende en SMS til dette nummer. Tjek nummeret, prøv e-mail-login, eller kontakt teamet, der inviterede dig.",
    smsLoginTextFailedOtpDisabled:
        "Vi fandt din konto, men kunne ikke sende en login-SMS. Log ind med din e-mail og adgangskode, eller kontakt teamet, der inviterede dig.",
    smsLoginTextFailedAccountFound:
        "Vi fandt din konto, men kunne ikke sende en login-SMS til dette nummer. Log ind med din e-mail, eller kontakt teamet, der inviterede dig for hjælp med SMS.",
    clinicianUpdateFailedDescription: "Kliniker kunne ikke opdateres. Prøv igen.",
    lockUnlockPartialFailure: (action, succeeded, failed, failedNames, firstError) =>
        `${succeeded} dagbøger ${action === "lock" ? "låst" : "låst op"}, ${failed} mislykkedes: ${failedNames} (${firstError})`,
    rolesAssignedToUsers: (role, assigned, failed) =>
        `Tildelte ${role} til ${assigned} brugere${failed ? `, ${failed} mislykkedes` : ""}`,
    pdfDownloadFailedDescription: "Det genererede PDF kunne ikke downloades",
    pdfGenerationFailedDescription: "PDF kunne ikke genereres",
    pdfDownloadSuccessDescription: "Din PDF er downloadet.",
};
